import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { DataProvider } from "../../Context";
import React from "react";
import CompanyInfo from "../CompanyInfo/CompanyInfo";
import Review from "../Review/Review";
import PolicyForm from "../PolicyPage/PolicyForm";
import GetStarted from "../GetStarted/GetStarted";
import CreateLogin from "../CreateLogin/CreateLogin";
import ProgressIndicator from "../../Components/ProgressIndicator";
import RequestAccess from "../RequestAccess/RequestAccess";
import Success from "../Success";
import HeaderFooter from "../../Layouts/HeaderFooter";
import Confirmation from "../Other/Confirmation/Confirmation";
import Error from "../Other/Error";
import NotFound from "../Other/NotFound";
import InvalidInvite from "../Other/InvalidInvite";
import Denied from "../Other/Denied";
import Required from "../../Components/Required";
import Blocked from "../Other/Blocked";
import { LocalizationProvider } from "../../Localization/LanguageContext";
import './styles.scss';
import Approve from "../Other/Approve";
import Deny from "../Other/Deny";
import Forwarded from "../Other/Forwarded";
import PermissionMappings from "../../PermissionMappings";
import { RequestProvider } from "../../Context/RequestContext";

function App() {
  return (
    <div className="app">
      <Router>
        <LocalizationProvider>
          <DataProvider>
            <HeaderFooter>
              <div className="page-container">
                <Routes>
                  <Route path="*" element={<NotFound />} />
                  <Route path="/" element={<GetStarted />}/>
                  <Route path="/GetStarted" element={<GetStarted/>} />
                  <Route path="/PolicyInfo" element={<Required><ProgressIndicator /><PolicyForm /></Required>} />
                  <Route path="/CompanyInfo" element={<Required><ProgressIndicator /><CompanyInfo /></Required>} />
                  <Route path="/Createlogin" element={<Required><ProgressIndicator /><CreateLogin /></Required>} />
                  <Route path="/Review" element={<Required><ProgressIndicator /><Review /></Required>} />
                  <Route path="/error" element={<Error/>}/>
                  <Route path="/confirmation" element={<Required><Confirmation /></Required>}/>
                  <Route path="/RequestAccess" element={<><RequestProvider><PermissionMappings /><RequestAccess /></RequestProvider></>} />
                  <Route path="/Success" element={<Success />} />
                  <Route path="/NotFound" element={<NotFound />}/>
                  <Route path="/Invalid" element={<InvalidInvite />}/>
                  <Route path="/Denied" element={<Denied />}/>
                  <Route path="/Blocked" element={<Blocked />}/>
                  <Route path="/approve/:key" element={<Approve />}/>
                  <Route path="/deny/:key" element={<Deny />}/>
                  <Route path="/forwarded" element={<Forwarded />}/>
                </Routes>
              </div>
            </HeaderFooter>
          </DataProvider>
        </LocalizationProvider>
      </Router>
    </div>
  );
}

export default App;
